import type { JSX } from "react";

/**
 * The aircraft beside the header's arrivals vital, drawn as stroke paths in
 * `currentColor` so it inherits the label's colour and scales with the mono
 * text. A top-down airliner — nose, swept wings, tailplane — rather than a
 * paper plane, because the cell counts people landing, and `PlaneGlyph` would
 * otherwise be the "send" arrow. Decorative: the count it sits beside carries
 * the reading for a screen reader, and the vital's own label names it.
 */
export function PlaneGlyph(): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2.5c1.2 0 2 1.1 2 2.5v5.4l7 4v2.3l-7-2.1v3.5l2.2 1.8v1.6L12 20.5l-4.2 1v-1.6l2.2-1.8v-3.5l-7 2.1v-2.3l7-4V5c0-1.4.8-2.5 2-2.5Z" />
    </svg>
  );
}
